module.exports = __webpack_public_path__ + "static/img/effect2.7d947f20.png";